var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Componente_26_7",
    "data-name": "Componente 26 \\u2013 7",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_326",
    "data-name": "Rect\\xE1ngulo 326",
    width: 20,
    height: 20,
    fill: "#38babf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_260",
    "data-name": "Grupo 260",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_659",
    "data-name": "Trazado 659",
    d: "M17.9,11.051,16.88,10.03a.724.724,0,0,0-.51-.211.732.732,0,0,0-.511.211l-4.924,4.932L8.73,12.748a.724.724,0,0,0-1.021,0L6.688,13.769a.724.724,0,0,0,0,1.021l3.738,3.738a.725.725,0,0,0,1.021,0L17.9,12.072a.726.726,0,0,0,.211-.511h0a.729.729,0,0,0-.211-.51",
    transform: "translate(-2.429 -3.682)",
    fill: "#38babf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_660",
    "data-name": "Trazado 660",
    d: "M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0m0,18.125A8.125,8.125,0,1,1,18.125,10,8.134,8.134,0,0,1,10,18.125",
    fill: "#20164d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleCheck);
export default __webpack_public_path__ + "static/media/circle_check.56147a227fded1ed383499528ea8824e.svg";
export { ForwardRef as ReactComponent };